import { concat, forEach, map } from 'lodash'
import { PackTraceData } from '../apis/packTrace.api'
import { TableHorizontalData } from '../components/TableHorizontal'
import { TableVerticalHeader } from '../components/TableVertical'

export default {
  appendLicensePlates (packTrace: TableHorizontalData<PackTraceData> | null) {
    if (packTrace && packTrace.case && packTrace.case.pallet) {
      packTrace.licensePlates = packTrace.case.pallet.licensePlates.join(', ')
    } else if (packTrace) {
      packTrace.licensePlates = packTrace.palletCode
    }
  },

  tableHorizontalData (
    packTraces: PackTraceData[]
  ): TableHorizontalData<PackTraceData>[] {
    forEach(packTraces, (packTrace: TableHorizontalData<PackTraceData>) => {
      packTrace.code = packTrace.case ? packTrace.case.code : packTrace.caseCode
      packTrace.actions = ['view']
      this.appendLicensePlates(packTrace)
    })
    return packTraces
  },

  tableVerticalHeaders (
    packTrace: PackTraceData | null
  ): TableVerticalHeader[] {
    const packTraceData = packTrace as TableHorizontalData<PackTraceData> | null
    if (packTraceData) {
      packTraceData.code = packTraceData.case ? packTraceData.case.code : packTraceData.caseCode
    }
    this.appendLicensePlates(packTraceData)
    const baseHeaders = [
      { heading: 'Pack trace', path: 'code' },
      { heading: 'Work order', path: 'workOrder.code' },
      { heading: 'Line number', path: 'lineNumber' },
      { heading: 'Latitude', path: 'latitude' },
      { heading: 'Longitude', path: 'longitude' },
      { heading: 'LPNs', path: 'licensePlates' },
      {
        heading: 'Created at',
        path: 'createdAt',
        date: true,
        tooltip: 'createdUser.username'
      }
    ]
    if (!packTrace || !packTrace.bundles) return baseHeaders
    const bundleHeaders = map(packTrace.bundles, (bundle, index) => {
      const heading = `${index + 1} scan code`
      const path = `bundles[${index}].code`
      return { heading, path }
    })
    return concat(baseHeaders, bundleHeaders)
  }
}
